import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout.js';
import Dashboard from './Dashboard.js';
import Projects from './pages/Projects.js';
import FileManagerPage from './pages/FileManagerPage.js';
import GenerateSOW from './pages/GenerateSOW.js';
import CftValidationPage from './pages/CftValidationPage.js';
import ReleaseMgt from './pages/ReleaseMgt.js';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Dashboard />} />
        <Route path="projects" element={<Projects />} />
        <Route path="files" element={<FileManagerPage />} />
        <Route path="generate" element={<GenerateSOW />} />
        <Route path="cft-validation" element={<CftValidationPage />} />
        <Route path="release-mgt" element={<ReleaseMgt />} />
      </Route>
    </Routes>
  );
}

export default App;